<div class="flex items-center justify-center w-full md:p-4">
    <span>O formulário já foi preenchido. Obrigado :)</span>
</div>
